module.exports = __webpack_public_path__ + "static/media/renault.df8c55d6.png";